export const USER_SUPERADMIN = "IFWADMIN";
export const USER_CASEDESIGNER = "CASEDESIGNER";
export const USER_CONCIERGE = "CONCIERGE";
export const USER_FINANCIALPROFESSIONAL = "FINANCIALPROFESSIONALS";

export const STATUS_INCOMPLETE = "STATUS_INCOMPLETE";
export const STATUS_PENDINGAPPROVAL = "STATUS_PENDINGAPPROVAL";
export const STATUS_PUBLISHED_V1 = "STATUS_PUBLISHED_V1";
export const STATUS_PUBLISHED_V2 = "STATUS_PUBLISHED_V2";

export const ACTION_SET_AUTHORIZATION = "ACTION_SET_AUTHORIZATION";
export const SAGA_LOGIN = "SAGA_LOGIN";
export const ACTION_SET_LOGINDATA = "ACTION_SET_LOGINDATA";
export const ACTION_SET_BADPASSWORD = "ACTION_SET_BADPASSWORD";
export const ACTION_SET_USER_LIST = "ACTION_SET_USER_LIST";
export const SAGA_CREATE_USER = "SAGA_CREATE_USER";
export const SAGA_EDIT_USER = "SAGA_EDIT_USER";
export const SAGA_FORGOT_PASSWORD = "SAGA_FORGOT_PASSWORD";
export const ACTION_LOGOUT = "ACTION_LOGOUT";
export const SAGA_GET_PLAN_CASH_FLOW = "SAGA_GET_PLAN_CASH_FLOW";

export const ACTION_SET_CURRENTPLAN_CASHFLOW = "ACTION_SET_CURRENTPLAN_CASHFLOW";
export const ACTION_SET_FUTUREPLAN_CASHFLOW = "ACTION_SET_FUTUREPLAN_CASHFLOW";
export const SAGA_GET_FUTURE_CASH_FLOW = "SAGA_GET_FUTURE_CASH_FLOW";

export const ACTION_CLEAR_FUTURE_CASH_FLOW = "ACTION_CLEAR_FUTURE_CASH_FLOW";

export const ACTION_SET_CURRENTFP_ID = "ACTION_SET_CURRENTFP_ID";

export const ACTION_OPEN_PASSWORD_CHANGE_SUCCESS_MODAL = "ACTION_OPEN_PASSWORD_CHANGE_SUCCESS_MODAL";

export const ACTION_CLOSE_PASSWORD_CHANGE_SUCCESS_MODAL = "ACTION_CLOSE_PASSWORD_CHANGE_SUCCESS_MODAL";

export const SAGA_GET_CURRENT_CASHINFLOW_OUTPUT = "SAGA_GET_CURRENT_CASHINFLOW_OUTPUT"
export const SAGA_GET_FUTURE_CASHINFLOW_OUTPUT = "SAGA_GET_FUTURE_CASHINFLOW_OUTPUT"
//PLAN Output
export const ACTION_SET_CURRENTCLIENT = "ACTION_SET_CURRENTCLIENT";
export const ACTION_SET_CURRENTUSER = "ACTION_SET_CURRENTUSER";

export const ACTION_SET_FORGOT_PASSWORD = "ACTION_SET_FORGOT_PASSWORD";
export const ACTION_LOCK_FUTURE_DESTINATION = "ACTION_LOCK_FUTURE_DESTINATION";

export const FILINGSTATUS_SINGLE = "FILINGSTATUS_SINGLE";
export const FILINGSTATUS_MARRIED = "FILINGSTATUS_MARRIED";

export const ACTION_SET_PLANINPUT = "ACTION_SET_PLANINPUT"
export const SAGA_GET_PLANINPUT = "SAGA_GET_PLANINPUT"

export const SAGA_RELOAD_USER_LIST = "SAGA_RELOAD_USER_LIST";

export const ACTION_OPEN_ACCOUNT_MENU = "ACTION_OPEN_ACCOUNT_MENU";

export const ACTION_UPDATE_EMAIL = "ACTION_UPDATE_EMAIL";

export const ACTION_SET_FINANCIAL_PROFESSIONAL = "ACTION_SET_FINANCIAL_PROFESSIONAL";

export const ACTION_SET_TRUST_LIST = "SET_TRUST_LIST";

export const ACTION_APPEND_TO_TRUST_LIST = "ACTION_APPEND_TO_TRUST_LIST";

export const FUNDING_SOURCE_EXCESS_INCOME = -1;
export const FUNDING_SOURCE_GUARANTEED_PAYOUTS = -2;

export const FUNDING_SOURCE_CURRENT_INCOME = -3;

export const PLAN_STATUS = {
  incomplete: "Incomplete",
  published: "Published",
  saved: "Saved",
  changed: "Changed",
}

export const ACCOUNT_TYPES = [
  {
    value: "NON-QUALIFIED",
    text: "Non-Qualified",
  },
  {
    value: "PRE-TAX",
    text: "Pre-Tax",
  },
  {
    value: "TAX-FREE",
    text: "Tax-Free",
  },
];

export const FIA_PAYOUTS = [
  {
    value: "LEVEL",
    text: "Level",
  },
  {
    value: "INCREASING",
    text: "Increasing",
  },
];

export const NONQUAL_ACCOUNTS = [
  {
    value: "BROKERAGE",
    text: "Brokerage",
  },
  {
    value: "INDIVIDUAL",
    text: "Individual",
  },
  {
    value: "JOINT_ACCOUNT",
    text: "Joint Account",
  },
  {
    value: "TE_OTHER",
    text: "Other",
  },
];

export const PRETAX_ACCOUNTS = [
  {
    value: "TD_401K",
    text: "401(k)",
  },
  {
    value: "TRADITIONAL_IRA",
    text: "Traditional IRA",
  },
  {
    value: "TD_403B",
    text: "403(B)",
  },
  {
    value: "TE_OTHER",
    text: "Other",
  },
];

export const TAXFREE_ACCOUNTS = [
  {
    value: "ROTH_IRA",
    text: "Roth IRA",
  },
  {
    value: 'TE_529_PLAN',
    text: '529 Plan'
  },
  {
    value: "ROTH_401K",
    text: "Roth 401(k)",
  },
  {
    value: 'TE_OTHER',
    text: 'Other'
  }

];

export const ROTH_CONVERSTION = [
  {
    value: "ALL",
    text: "All",
  },
  {
    value: "FIXED_AMOUNT",
    text: "Fixed",
  },
];

export const ROTH_DESTINATION_ROTH_IRA = "ROTH_IRA";
export const ROTH_DESTINATION_VOLATILITY_BUFFER_FIA = "VOLATILITY_BUFFER_FIA";
export const ROTH_DESTINATION_LEVEL_INCOME_FIA = "LEVEL_INCOME_FIA";
export const ROTH_DESTINATION_INCREASING_PAYOUT_FIA = "INCREASING_PAYOUT_FIA";
export const ROTH_DESTINATION_RILA = "ROTH_DESTINATION_RILA";

export const ROTH_DESTINATION = [
  {
    value: ROTH_DESTINATION_ROTH_IRA,
    text: "Roth IRA"
  },
  {
    value: ROTH_DESTINATION_VOLATILITY_BUFFER_FIA,
    text: "Volatility Buffer FIA"
  },
  {
    value: ROTH_DESTINATION_LEVEL_INCOME_FIA,
    text: "Level Income FIA"
  },
  {
    value: ROTH_DESTINATION_INCREASING_PAYOUT_FIA,
    text: "Increasing Payout FIA"
  },
  {
    value: ROTH_DESTINATION_RILA,
    text: "RILA"
  }
]

export const INCOME_TYPES = [
  {
    value: "PAYROLL",
    text: "Payroll",
  },
  {
    value: "SOCIAL_SECURITY",
    text: "Social Security",
  },
  {
    value: "PENSION",
    text: "Pension",
  },
  {
    value: "OTHER",
    text: "Other",
  },
];

export const MAX_CURRENCY = 1000000000;
export const MAX_CURRENCY_FUTURE_ADJUSMENTS = 10000000;
export const MAX_YEAR = 2100;
